import React from 'react';
import {
    IconProps,
    Link as MUILink,
    LinkProps as MUILinkProps,
} from '@material-ui/core';
import {
    Link as RouterLink,
    LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import styled from 'styled-components';

type LinkProps = MUILinkProps & RouterLinkProps;

interface IProps extends LinkProps {
    hash?: boolean;
    icon?: IconProps;
}

const BaseLink = ({
    children,
    className,
    hash,
    href,
    icon,
    ...other
}: IProps) => (
    <MUILink
        className={className}
        color="primary"
        component={hash ? HashLink : href ? 'a' : RouterLink}
        href={href}
        variant="body1"
        {...other}
    >
        {icon} {children}
    </MUILink>
);

export const Link = styled(BaseLink)`
    .MuiSvgIcon-root {
        position: relative;
        top: 3px;
        font-size: ${({ theme }) => theme.typography.body1.fontSize};
        margin-right: ${({ theme }) => `${theme.spacing(2)}px`};
    }
`;
